export const wstBackgroundImages = {
  registerWstIndex0: require('@/assets/wst/register/1.jpg'),
  registerWstIndex1: require('@/assets/wst/register/1.jpg'),
  registerWstIndex2: require('@/assets/wst/register/2.jpg'),
  registerWstIndex3: require('@/assets/wst/register/3.jpg'),
  registerWstIndex4: require('@/assets/wst/register/4.jpg'),
  registerWstIndex5: require('@/assets/wst/register/5.jpg'),
  registerWstIndex6: require('@/assets/wst/register/6.jpg'),
  registerWstIndex7: require('@/assets/wst/register/7.jpg'),
  registerWstIndex8: require('@/assets/wst/register/8.jpg'),
  registerWstIndex9: require('@/assets/wst/register/9.jpg'),
  registerWstIndex10: require('@/assets/wst/register/10.jpg'),
  registerWstIndex12: require('@/assets/wst/register/11.jpg'),
};
